export default __webpack_public_path__ + "static/media/Path 1463@2x.ce295f69.png";